(function () {
  const REQUIRED_PATH = "/pages/goddiva-unlimited";
  const REQUIRED_PARAM = "auto-checkout";
  const REQUIRED_VALUE = "yes";
  const REQUIRED_COUNTRY = "GB";
  const VARIANT_ID = window.gdUnlimitedId;
  const GEO_API = "https://pro.ip-api.com/json/?key=XjCy8wkn8k9YuLG&fields=status,country,countryCode";
  if (!VARIANT_ID || String(VARIANT_ID).trim() === "") {
    return;
  }
    
  function isCorrectPage() {
    const url = new URL(window.location.href);
    return (
      url.pathname === REQUIRED_PATH &&
      url.searchParams.get(REQUIRED_PARAM) === REQUIRED_VALUE
    );
  }

  function redirectToCheckout() {
    window.location.href = "/checkout";
  }

  function checkCartThenProceed() {
    if (!window.Shopify || typeof Shopify.getCart !== "function") {
      addToCartAndCheckout();
      return;
    }

    Shopify.getCart(cart => {
      const alreadyInCart = cart.items.some(
        item => String(item.variant_id) === String(VARIANT_ID)
      );

      if (alreadyInCart) {
        redirectToCheckout();
      } else {
        addToCartAndCheckout();
      }
    });
  }

  function addToCartAndCheckout() {
    if (!VARIANT_ID) return;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: VARIANT_ID,
        quantity: 1
      })
    })
      .then(res => {
        if (!res.ok) throw new Error("Add to cart failed");
        redirectToCheckout();
      })
      .catch(err => console.error("Cart error:", err));
  }

  function checkViaGeoAPI() {
    fetch(GEO_API)
      .then(res => res.json())
      .then(data => {
        if (
          data &&
          data.status === "success" &&
          data.countryCode === REQUIRED_COUNTRY
        ) {
          checkCartThenProceed();
        }
      })
      .catch(err => console.error("Geo API error:", err));
  }

  if (!isCorrectPage()) return;

  const countryCode = document.body.getAttribute("data-country-code");

  if (countryCode === REQUIRED_COUNTRY) {
    checkCartThenProceed();
  } else if (!countryCode) {
    checkViaGeoAPI();
  }
})();